var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
/**
 * Get all events for a specific level.
 */
export function getLevelEvents(levelId) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/levels/${levelId}/events`);
    });
}
/**
 * Get a specific event by its ID.
 */
export function getEventById(levelId, eventId) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/levels/${levelId}/events/${eventId}`);
    });
}
/**
 * Create a new event for a level.
 */
export function createEvent(levelId, eventData) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.post(`/levels/${levelId}/events`, eventData);
    });
}
/**
 * Update an existing event.
 */
export function updateEvent(levelId, eventId, eventData) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.patch(`/levels/${levelId}/events/${eventId}`, eventData);
    });
}
/**
 * Delete an event — it is archived server-side (restorable) and detached from
 * every map cell it was placed on.
 */
export function deleteEvent(levelId, eventId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield client.delete(`/levels/${levelId}/events/${eventId}`);
    });
}
/** The archive: soft-deleted events, restorable below the active list. */
export function getArchivedEvents(levelId) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/levels/${levelId}/events-archive`);
    });
}
/** Bring an archived event back (it returns unattached — re-place it on the map). */
export function restoreEvent(levelId, eventId) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.post(`/levels/${levelId}/events/${eventId}/restore`, {});
    });
}
/**
 * Get all events of the encounter type for a level
 */
export const getLevelEncounters = (levelId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        // Use apiClient instead of fetch directly
        const events = yield client.get(`/levels/${levelId}/events`);
        // Filter only events of type encounter
        return events.filter((event) => event.isEncounter);
    }
    catch (error) {
        console.error('Error fetching level encounters:', error);
        throw error;
    }
});
